<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      }
  },
  mounted(){
    if (this._isMobile()) {
      localStorage.setItem('client', "phone");
      // this.$router.replace('/mi');
    } else {
      localStorage.setItem('client', "pc");
      // this.$router.replace('/test');
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue